export const CI_LENGTH = 14;
